module.exports = __webpack_public_path__ + "static/img/nose_04.833f3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_04.png
// module id = 1o1D
// module chunks = 0